export enum TableAction {
    tableReset = 'tableReset',
    tableFilterApplied = 'tableFilterApplied',
    tableFilterReset = 'tableFilterReset',
    tableFilterSorted = 'tableFilterSorted',
    tableExportClicked = 'tableExportClicked',
    tableHeaderNameClicked = 'tableHeaderNameClicked',
}
